// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5fbff505","453":"ab8e6691","455":"51691bb5","977":"d2f6358f"}[chunkId] + ".chunk.js";
};